// extracted by mini-css-extract-plugin
export default {"interestTagBody":"styles_interestTagBody__+ySLa"};